import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import book1 from '../../images/icons/book1.svg';
import book2 from '../../images/icons/book2.svg';
import book3 from '../../images/icons/book3.svg';
import book4 from '../../images/icons/book4.svg';
import book5 from '../../images/icons/book5.svg';
import books_background from '../../images/icons/books_background.svg';
import routeList from '../../routes/routeList';
import { withRouter } from 'react-router-dom';

const program = [
  { img: book1, schoolType: 'Szkoła podstawowa', range: 'I - III', url: 'range/34', name: 'klasy I-III' },
  { img: book2, schoolType: 'Szkoła podstawowa', range: 'IV - VI', url: 'range/22', name: 'klasy IV-VI' },
  { img: book3, schoolType: 'Szkoła podstawowa', range: 'VII - VIII', url: 'range/7', name: 'klasy VII-VIII' },
  { img: book4, schoolType: 'Liceum', range: 'Poziom podstawowy', url: 'range/10', name: 'liceum zakres podstawowy' },
  { img: book5, schoolType: 'Liceum', range: 'Poziom rozszerzony', url: 'range/18', name: 'liceum zakres rozszerzony' }
];

const showCategoryPage = (url, categoryName, history) => {
  history.push({ pathname: `${routeList.category}/${url}`, state: { category_name: categoryName } });
};

const HomeProgramItem = withRouter(({ item, history }) => {
  const [hover, setHover] = useState(false);
  const handleHover = () => {
    setHover(hover => !hover);
  };

  return (
    <Col sm="12" md="5" xl="auto" className="program-card">
      <div className="program-card-image">
        <img
          src={books_background}
          alt="Tło ikony zakresu"
          className={hover ? 'program-book-img-bg-hover' : 'program-book-img-bg'}
        />
        <img src={item.img} alt="Ikona zakresu - szkoła podstawowa klasy 1-3" className="img-fluid program-book-img" />
      </div>
      <h4 className="title">{item.schoolType}</h4>
      <h5>{item.range}</h5>
      <button
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
        className="btn-primary"
        onClick={() => showCategoryPage(item.url, item.name, history)}
      >
        Sprawdź lektury
      </button>
    </Col>
  );
});

const HomeProgram = () => {
  return (
    <Row className="justify-content-center">
      {program.map(item => (
        <HomeProgramItem item={item} key={item.range} />
      ))}
    </Row>
  );
};

HomeProgramItem.propTypes = {
  item: PropTypes.shape({
    img: PropTypes.string.isRequired,
    schoolType: PropTypes.string.isRequired,
    range: PropTypes.string.isRequired
  })
};

export default HomeProgram;
